import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
} from '@chakra-ui/react'
import OccupationForm from './OccupationForm'

interface OccupationModalProps {
  id?: string
  isOpen: boolean
  onClose: () => void
  occupationName: string
  setOccupationName: (name: string) => void
  startDate: string
  setStartDate: (date: string) => void
  endDate: string
  setEndDate: (date: string) => void
  stressLevel: string
  setStressLevel: (level: string) => void
  handleSave: () => Promise<void>
  extraInfoRequired: boolean
}

function OccupationModal({
  id,
  isOpen,
  onClose,
  occupationName,
  setOccupationName,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  stressLevel,
  setStressLevel,
  handleSave,
  extraInfoRequired,
}: OccupationModalProps) {
  const handleClose = () => {
    setOccupationName('')
    setStartDate('')
    setEndDate('')
    setStressLevel('')
    onClose()
  }

  const handleSaveAndClose = async () => {
    try {
      // Wait for handleSave to complete - it will throw an error if validation fails
      await handleSave()
      // Only close if handleSave succeeds (no validation errors)
      handleClose()
    } catch (error) {
      // Do not close the modal if there's a validation error
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{id ? 'Update Occupation' : 'Add Occupation'}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <OccupationForm
            occupationName={occupationName}
            setOccupationName={setOccupationName}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            stressLevel={stressLevel}
            setStressLevel={setStressLevel}
            extraInfoRequired={extraInfoRequired}
          />
        </ModalBody>
        <ModalFooter>
          <Button colorScheme='blue' mr={3} onClick={handleSaveAndClose}>
            Save
          </Button>
          <Button variant='ghost' onClick={handleClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default OccupationModal
